import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Text from '../../../../shared/components/Text/Text';

const SideBarTitleWrapper = ({ title }) => {
  const sideBarDataTag = useSelector((state) => state.calendar.data.primarySideBarDataTag);

  // When an explicit title is passed (e.g. the previewed athlete's name), render it directly.
  if (title) {
    return (
      <Text fontWeight={700} fontSize='13px' style={{ paddingBottom: '16px' }}>{title}</Text>
    );
  }

  const getTitle = () => {
    switch (sideBarDataTag) {
      case 'tag':
        return 'Tag';
      case 'comment':
        return 'Comment';
      case 'folder':
        return 'Folder';
      case 'lift':
        return 'Exercises';
      case 'phone':
        return 'Phone';
      case 'checkmark':
        return 'Checkmark';
      default:
        return '';
    }
  };

  if (sideBarDataTag !== 'calendar2') {
    return (
      <Text fontWeight={700} fontSize='13px'>{getTitle()}</Text>
    );
  }
  return null;
};

SideBarTitleWrapper.defaultProps = {
  title: '',
};

SideBarTitleWrapper.propTypes = {
  title: PropTypes.string,
};

export default SideBarTitleWrapper;
